import { useState, useEffect } from 'react';

import config from '@/../tailwind.config';
import { debounce } from '@/utils/debounce';

export const getMediaQueryMatches = (screen: string): boolean => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const screenConfig = (config.theme?.extend?.screens as any)?.[screen];
  if (!screenConfig || !screenConfig.raw) {
    throw new Error(`Missing screen configuration for ${screen}`);
  }
  return window.matchMedia(screenConfig.raw).matches;
};

export const useIsScreenSize = (screen: string): boolean => {
  const [isMatch, setIsMatch] = useState(() => getMediaQueryMatches(screen));

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMatch(getMediaQueryMatches(screen));
    }, 200);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [screen]);

  return isMatch;
};
